__turbopack_context__.v({
  "centeredContent": "c5Hm5a_centeredContent",
  "pageLayout": "c5Hm5a_pageLayout",
  "statusNotification": "c5Hm5a_statusNotification",
  "tabSubtitle": "c5Hm5a_tabSubtitle",
  "tabTitleDesktop": "c5Hm5a_tabTitleDesktop",
  "tabTitleMobile": "c5Hm5a_tabTitleMobile",
  "tableTitleWrapper": "c5Hm5a_tableTitleWrapper",
  "tabsWrapper": "c5Hm5a_tabsWrapper",
});
